const NavigateUtil = {
  ctx: null,
  init(ctx) {
    this.ctx = ctx;
  },
  
  goHome(){
    this.naveTo({vue: this.ctx, path: this.ctx.$router_path.home})
  },
  
  goLogin(){
    this.naveTo({vue: this.ctx, path: this.ctx.$router_path.login})
  },
  
  goBack(){
    if(window.client.ios){
      this.ctx.$store.showLeaveAnim = true
    }
    this.ctx.$router.back()
  },
  
  goBindPhone(){
    this.naveTo({vue: this.ctx, path: this.ctx.$router_path.phoneBind})
  },
  
  goBindRealName(){
    this.naveTo({vue: this.ctx, path: this.ctx.$router_path.RealName})
  },
  
  naveTo(param){
    if(param.hasOwnProperty('param')){
      param.vue.$router.push({name:param.path, params: {'detail': param.param}})
    }else{
      if(param.vue && param.vue.$router){
        param.vue.$router.push(param.path)
      }
    }
  },
  
  naveCheck(){
    
    if(this.ctx.$info.loginOK == true){
      if(this.ctx.$info.isGuestAccount()){
        this.showToastNormal('更多功能,请先登录');
        
        if(isWeiXinBrowser()){
            this.naveToWxinLogin()
        }else{
          this.naveTo({vue: this.ctx, path: this.ctx.$router_path.login});
        }
        return false;
      }
    }else{
      this.showToastNormal('更多功能,请先登录')
      if(isWeiXinBrowser()){
        this.naveToWxinLogin()
      }else{
        this.naveTo({vue: this.ctx, path: this.ctx.$router_path.login});
      }
      return false;
    }
    return true;
  },
  
  naveToLogin(){
    if(isWeiXinBrowser()){
      this.naveToWxinLogin()
    }else{
      this.ctx.$store.commit('naveTo', {vue: this.ctx, path: this.ctx.$router_path.login})
    }
  },
  
  naveToWxinLogin(){
    let obj = {}
    // obj.host = encodeURI(location.href.split('#')[0])
    obj.deviceCode = this.ctx.$device.deviceCode
    obj.deviceType = this.ctx.$device.deviceType
    obj.deviceInfo = this.ctx.$device.deviceInfo
  
    let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3449b79e9e4410d9&redirect_uri=https://www.you1quan.com/center/wexin/mp/login&response_type=code&scope=snsapi_userinfo'
    url +=  '&state=' + JSON.stringify(obj)
    url += '#wechat_redirect'
    
    window.open(encodeURI(url))
    
    this.ctx.$info.type = 3;
  },
  
  showToastNormal(msg){
    this.showToast({msg: msg})
  },
  
  showToast(setup){
    this.ctx.$toast({message: setup.msg,
      position: 'bottom',
      duration: 2000})
    
  },
}

NavigateUtil.install = function (Vue, options) {
  Vue.prototype.$nav_util = NavigateUtil
}

export default NavigateUtil



// WEBPACK FOOTER //
// ./src/plugins/navigate-util.js